// src/util/environment-helpers.ts
import { getConfig } from "@leagueplatform/config";
var getEnvironment = () => getConfig().config.core.appEnvironment;
var isProduction = () => getEnvironment() === "production";
var isStaging = () => getEnvironment() === "staging";
var isDev = () => getEnvironment() === "development";
var isNodeTestEnv = () => {
  var _a;
  const nodeEnvPropName = "NODE_ENV";
  return typeof process !== "undefined" && ((_a = process.env) == null ? void 0 : _a[nodeEnvPropName]) === "test";
};
var isStorybook = () => typeof window !== "undefined" && "IS_STORYBOOK" in window;

// src/app-environment.ts
var AppEnvironment = {
  get environment() {
    return getEnvironment();
  }
};

// src/util/environment-constants.ts
var ENVIRONMENT = /* @__PURE__ */ ((ENVIRONMENT2) => {
  ENVIRONMENT2["PRODUCTION"] = "production";
  ENVIRONMENT2["STAGING"] = "staging";
  ENVIRONMENT2["DEV"] = "development";
  return ENVIRONMENT2;
})(ENVIRONMENT || {});
export {
  AppEnvironment,
  ENVIRONMENT,
  getEnvironment,
  isDev,
  isNodeTestEnv,
  isProduction,
  isStaging,
  isStorybook
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/app-environment'] = window.leagueSDKsPresent['@leagueplatform/app-environment'] || [];
    window.leagueSDKsPresent['@leagueplatform/app-environment'].push('2.25.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/app-environment'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/app-environment module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map